<template>
  <div class="bottle-list">
    <div class="bottle-list-item" v-for="(it, i) in bottleListData" :key="i">
      <img src="@/assets/images/Scan_code_icon_bottle.png" alt="">
      <div class="w_100">
        <div class="d_f">
          <div class="flex_1">气瓶二维码</div>
          <div class="bottle-code" @click="showBottleUserInfo(i)">{{it.ewm}}</div>
        </div>
        <div class="d_f">
          <div class="flex_1">出产编号</div>
          <div class="bottle-code">{{it.can_release_no}}</div>
        </div>
        <van-icon v-if="bottleIdList.length != 1" name="cross" @click="$store.state.bottleIdList.splice(i, 1)"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    bottleIdList(){
      
      return this.$store.state.bottleIdList
    },
    bottleListData(){
      return this.$store.state.bottleIdList.map(item => this.$store.state.bottleListData.find(it => it.ewm == item))
      // return this.$store.state.bottleListData
    }
  },
  methods: {
    showBottleUserInfo(i){
      console.log("hhhhh", this.bottleListData)
      this.$emit("showBottleUserInfo", this.bottleListData[i])
    }
  }
}
</script>

<style lang="scss" scoped>
.bottle-list{
  width: 92vw;
  margin-left: 4vw;
  .bottle-list-item{
    display: flex;
    align-items: center;
    background: white;
    border-radius: 1vw;
    margin-top: 3vw;
    padding: 1vw 3vw;
    position: relative;
    padding-right: 7vw;
    img{
      margin-right: 1vw;
    }
      .van-icon-cross{
        width: 4vw;
        height: 4vw;
        background: #FF0000;
        border-radius: 50%;
        color: white;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 4vw;
        position: absolute;
        right: 2vw;
        top: calc(50% - 2vw);
      }
  }
}
  .d_f{
    display: flex;
    line-height: 7vw;
    font-size: 4vw
  }
  .w_100{
    width: 100%
  }
  .flex_1{
    flex: 1
  }

</style>